import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Copy } from 'lucide-react';
import { Button, type ButtonSize } from './Button';
import { toast } from './Toast';

export interface CopyButtonProps {
  value: string;
  /** Visible label (defaults to "Copy"). */
  label?: string;
  size?: ButtonSize;
  onCopied?: () => void;
}

export function CopyButton({ value, label, size = 'sm', onCopied }: CopyButtonProps) {
  const { t } = useTranslation('common');
  const [copied, setCopied] = useState(false);
  return (
    <Button
      variant="secondary"
      size={size}
      leadingIcon={copied ? Check : Copy}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(value);
          setCopied(true);
          onCopied?.();
          toast({ tone: 'success', title: t('copy.done') });
          window.setTimeout(() => setCopied(false), 2000);
        } catch {
          toast({ tone: 'warning', title: t('copy.failed') });
        }
      }}
    >
      {label ?? t('copy.label')}
    </Button>
  );
}
